// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.RaffleModal_boxModal__nYkW\\+ {
  animation: RaffleModal_init__4F5jb 0.3s;
  transition: 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  min-height: 500px;
  border-radius: 10px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
  font-size: 16px;
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_exit__AAIQu {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 40px;
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_exit__AAIQu .RaffleModal_exitIcon__Yi39l {
  transition: 0.3s;
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_exit__AAIQu .RaffleModal_exitIcon__Yi39l:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_titleModal__ZgoCl {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_titleModal__ZgoCl p {
  font-size: 1.5rem;
  margin: 0;
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_titleModal__ZgoCl span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_loader__DnXHD {
  transition: 0.5s;
  min-height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_data__3h0kX {
  transition: 0.5s;
  max-height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.RaffleModal_boxModal__nYkW\\+ .RaffleModal_data__3h0kX .RaffleModal_tableContainer__m3fxe {
  animation: RaffleModal_init2__LbIEY 0.3s both 0.3s;
  max-height: 50vh;
  overflow-y: scroll;
  border-radius: 5px;
}

@media screen and (max-width: 900px) {
  .RaffleModal_boxModal__nYkW\\+ {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@keyframes RaffleModal_init__4F5jb {
  0% {
    top: 55%;
    opacity: 0;
  }
  100% {
    top: 50%;
    opacity: 1;
  }
}

@keyframes RaffleModal_init2__LbIEY {
  0% {
    transform: translateX(30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/VentasTelekino/UploadModal/RaffleModal/RaffleModal.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,uCAAoB;EACpB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kDAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.3s;\n  transition: 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  min-height: 500px;\n  border-radius: 10px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n  font-size: 16px;\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n  margin-bottom: 40px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.5rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .loader {\n  transition: 0.5s;\n  min-height: 600px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .data {\n  transition: 0.5s;\n  max-height: 600px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .data .tableContainer {\n  animation: init2 0.3s both 0.3s;\n  max-height: 50vh;\n  overflow-y: scroll;\n  border-radius: 5px;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n@keyframes init {\n  0% {\n    top: 55%;\n    opacity: 0;\n  }\n  100% {\n    top: 50%;\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `RaffleModal_boxModal__nYkW+`,
	"init": `RaffleModal_init__4F5jb`,
	"exit": `RaffleModal_exit__AAIQu`,
	"exitIcon": `RaffleModal_exitIcon__Yi39l`,
	"titleModal": `RaffleModal_titleModal__ZgoCl`,
	"loader": `RaffleModal_loader__DnXHD`,
	"data": `RaffleModal_data__3h0kX`,
	"tableContainer": `RaffleModal_tableContainer__m3fxe`,
	"init2": `RaffleModal_init2__LbIEY`
};
export default ___CSS_LOADER_EXPORT___;
